import React, { useState } from 'react'
import { GifPlayer } from './GifPlayer.js'
import { shouldRenderAsGif } from '../utils/gifUtils.js'

interface SmartImageProps {
  src: string
  alt?: string
  className?: string
  onClick?: () => void
  width?: number
  height?: number
}

export const SmartImage: React.FC<SmartImageProps> = ({
  src,
  alt = '',
  className = '',
  onClick,
  width,
  height,
}) => {
  const [gifPlayerFailed, setGifPlayerFailed] = useState(false)
  const isGif = shouldRenderAsGif(src)

  // If it's not a GIF or GIF player failed, use regular img
  if (!isGif || gifPlayerFailed) {
    return (
      <img
        className={className}
        src={src}
        alt={alt}
        onClick={onClick}
        style={{
          width: width ? `${width}px` : '100%',
          height: height ? `${height}px` : 'auto',
          maxWidth: '100%',
          display: 'block',
        }}
      />
    )
  }

  // Try GIF player, with fallback to img if it fails
  return (
    <div>
      <GifPlayer
        src={src}
        alt={alt}
        className={className}
        onClick={onClick}
        width={width}
        height={height}
      />
      {/* Hidden fallback img that will show if GIF player fails */}
      <img
        className={className}
        src={src}
        alt={alt}
        onClick={onClick}
        style={{
          width: width ? `${width}px` : '100%',
          height: height ? `${height}px` : 'auto',
          maxWidth: '100%',
          display: 'none', // Hidden by default
        }}
        onError={() => {
          console.log('GIF player failed, falling back to img')
          setGifPlayerFailed(true)
        }}
      />
    </div>
  )
}

export default SmartImage
